<template>
  <div class="important-page-c display--flex fd--column">
    <!-- 搜索 -->
    <div
      class="search-form btn-2b5a95"
    >
<div class="l-w" :style="{
        height: $store.state.global.isSearchExtend_1
          ? ''
          : $store.state.global.searchFormHeight_1 + 10 + 'px',
      }">
      <el-form
        label-position="right"
        :class="$store.state.global.isSearchExtend_1 ? '' : 'overflow--hidden'"
				:model="searchForm"
				@submit.native.prevent
      >
        <el-form-item label="学生姓名:">
          <el-input 
						v-model.trim="searchForm.studentname" 
						@keyup.enter.native="seach"
						clearable />
        </el-form-item>
        <el-form-item label="项目类型:">
          <el-select 
						v-model="searchForm.projecttype" 
						@visible-change="visibleType"
						@keyup.enter.native="seach"
						ref="projecttyperef"
						clearable>
            <el-option
              v-for="item in tech_projectTyles"
              :key="item.key"
              :label="item.val"
              :value="item.val"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="班别:">
          <el-input 
						v-model.trim="searchForm.fudaoclasstypename" 
						@keyup.enter.native="seach"
						clearable />
        </el-form-item>
        <el-form-item label="教学点:">
          <el-input 
						v-model.trim="searchForm.schoolorgname" 
						@keyup.enter.native="seach"
						clearable />
        </el-form-item>
      </el-form>
    </div>
      <div class="r-w">

      <el-button
        type="primary"
        icon="el-icon-search"
        @click="getDataList"
        :loading="!$store.state.global.isEndRequest"
        class="btn-2b5a95"
        >搜索</el-button
      >
			<el-button type="primary" @click="resetQuery">重置</el-button>
      <el-button
        type="primary"
        :icon="
          $store.state.global.isSearchExtend_1
            ? 'el-icon-arrow-up'
            : 'el-icon-arrow-down'
        "
        v-if="$store.state.global.searchExtend_1"
        class="btn-2b5a95"
        @click="onExtendClick('isSearchExtend_1')"
        >{{ $store.state.global.searchExtendText_1 }}</el-button
      >
    </div>

    </div>

    <!-- 按钮操作 -->
    <div
      class="Btn-w eaf4ff-btn"
      v-if="tableRes.buttonlist && tableRes.buttonlist.length"
      :style="{
        height: $store.state.global.isBtnExtend_1
          ? ''
          : $store.state.global.BtnHeight_1 + 10 + 'px',
      }"
    >
      <div
        class="btn-l"
        v-if="tableRes.buttonlist"
        :class="$store.state.global.isBtnExtend_1 ? '' : 'overflow--hidden'"
      >
        <el-button
          v-for="(item, index) in tableRes.buttonlist"
          :key="index"
          type="primary"
          @click="onClickBtn(item.buttonname)"
          >{{ item.name }}
        </el-button>
      </div>
      <div class="Btn-extend">
        <el-button
          type="primary"
          v-if="$store.state.global.btnExtend_1"
          class="btn-2b5a95"
          :icon="
            $store.state.global.isBtnExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          @click="onExtendClick('isBtnExtend_1')"
          >{{ $store.state.global.BtnExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableRes.list"
      stripe
      border
      :header-cell-style="{ background: '#044d8c', color: '#fff'}"
      ref="multipleTable"
      style="width: 100%"
      :cell-style="{padding:0}"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="学生姓名" prop="studentname" align="center">
        <template slot-scope="scope" align="center">
          <el-button @click="btnShowDetail(scope.row)" type="text">{{
            scope.row.studentname
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="身份证"
        prop="idcard"
        align="center"
        width="150"
      />
      <el-table-column label="项目类型" prop="projecttype" align="center" />
      <el-table-column
        label="班别"
        prop="fudaoclasstypename"
        align="center"
        width="300"
      />
      <el-table-column label="跟进人" prop="followusername" align="center" />
      <el-table-column label="教学点" prop="schoolorgname" align="center" />
			<el-table-column label="操作" align="center" width="150">
			  <template slot-scope="scope" align="center">
			    <el-button @click="btnShow(scope.row)" type="text"
			      >查看详情</el-button
			    >
			  </template>
			</el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="pageinfo.pageindex"
      :page-size="pageinfo.pagesize"
      :page-sizes="[10, 20, 30, 40, 50]"
      layout="total, prev, pager, next, jumper"
      :total="tableRes.totalcount"
    ></el-pagination>

    <!-- 查看详情 -->
    <el-dialog
      class="btn-2b5a95"
      :width="$store.state.global.isFullscreen ? 'width: 100%' : 'width: 80%'"
      :fullscreen="$store.state.global.isFullscreen"
      :visible.sync="showDetailModal"
      v-if="showDetailModal"
			:close-on-click-modal='false'
      append-to-body
      @closed="$store.state.global.isFullscreen = false"
    >
      <span slot="title" class="el-dialog__title">
        <span>{{ dialogTitle }}</span>
        <span
          :class="
            $store.state.global.isFullscreen
              ? 'el-icon-copy-document'
              : 'el-icon-full-screen'
          "
          @click="isExpand($store.state.global.isFullscreen)"
        ></span>
      </span>
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        label-width="30%"
        class="demo-dynamic form-item-w-33"
        status-icon
        :rules="rules"
      >
        <el-form-item label="流水号:">
          {{ dynamicValidateForm.id }}
        </el-form-item>
        <el-form-item label="学生姓名:">
          {{ dynamicValidateForm.studentname }}
        </el-form-item>
        <el-form-item label="手机号:">
          {{ dynamicValidateForm.mobile }}
        </el-form-item>
        <el-form-item label="身份证:">
          {{ dynamicValidateForm.idcard }}
        </el-form-item>
        <el-form-item label="班别:">
          {{ dynamicValidateForm.fudaoclasstypename }}
        </el-form-item>
        <el-form-item label="项目类型:">
          {{ dynamicValidateForm.projecttype }}
        </el-form-item>
        <el-form-item label="跟进人:">
          {{ dynamicValidateForm.followusername }}
        </el-form-item>
        <el-form-item label="录入时间:">
          {{
            dynamicValidateForm.inserttime | formatDate("YYYY-MM-DD HH:mm:ss")
          }}
        </el-form-item>
        <el-form-item label="所属教学点:">
          {{ dynamicValidateForm.schoolorgname }}
        </el-form-item>
        <el-form-item label="所属分公司:">
          {{ dynamicValidateForm.companyorgname }}
        </el-form-item>
        <el-form-item label="备注:">
          {{ dynamicValidateForm.remark }}
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 查看详情 -->
    <el-dialog
      class="btn-2b5a95"
      width="50%"
			v-dialogDrag
      title="查看详情："
      :visible.sync="showModal"
			:close-on-click-modal='false'
			v-if="showModal"
      append-to-body
    >
      <div class="select-btn">
        <el-button type="primary" @click="btnDetailEdit">修改</el-button>
        <el-button type="primary" @click="btnDetailDel">删除</el-button>
      </div>

      <el-table
        :data="showTable.list"
        style="width: 100%"
        ref="moneyTable"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="流水号" prop="id" align="center" />
        <el-table-column label="学生姓名" prop="studentname" align="center" />
        <el-table-column label="考试类型" prop="examtype" align="center" />
        <el-table-column label="科目名称" prop="coursename" align="center" />
        <el-table-column label="分数" prop="score" align="center" />
        <el-table-column label="是否需要补考" align="center">
          <template slot-scope="scope">
            {{ status[scope.row.status] }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="handleShowChange"
        :current-page="pageinfo.pageindex"
        :page-size="pageinfo.pagesize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, prev, pager, next, jumper"
        :total="showTable.totalcount"
      ></el-pagination>
    </el-dialog>

    <!--详情的修改-->
    <el-dialog
      class="btn-2b5a95"
      width="500px"
			v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDetailEditModal"
			:close-on-click-modal='false'
			v-if="showDetailEditModal"
      append-to-body
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        label-width="100px"
        class="demo-dynamic form-item-w-100"
        status-icon
        :rules="rules"
      >
        <el-form-item label="姓名:">
          <el-input v-model="dynamicValidateForm.followusername" disabled />
        </el-form-item>
        <el-form-item label="考试类型:">
          <el-select v-model="dynamicValidateForm.examtype" clearable>
            <el-option value="模拟考试"></el-option>
            <el-option value="证书考试"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目名称:">
          <el-input v-model="dynamicValidateForm.coursename" />
        </el-form-item>
        <el-form-item label="分数:">
          <el-input v-model="dynamicValidateForm.score" />
        </el-form-item>
        <el-form-item label="是否补考:">
          <el-select v-model="dynamicValidateForm.status">
            <el-option value="1" label="是"></el-option>
            <el-option value="0" label="否"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveDetail('dynamicValidateForm')"
          >提交
        </el-button>
      </span>
    </el-dialog>

    <!-- 导入成绩 -->
    <Import
      :importDialog="importDialog2"
      :importSaveUrl="importSaveUrl2"
      @onCloseImport="onCloseImport2"
      @getDataList="getDataList"
      downloadUrl="download/教学管理/技能/技能成绩导入模板.xls"
    ></Import>
  </div>
</template>

<script>
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";
import Export from "@/components/Export/index.vue";
import Import from "@/components/Import/index.vue";

import {
  techexam_list,
  techexam_input,
  techexam_save,
  techexamdetail_save,
  techexamdetail_input,
  techexamdetail_delete,
  techexam_delete,
  techexam_importsave,
  techexamdetail_list,
  techexamdetail_importsave,
  techexamdetail_exportscore,
  techfudao_dialogresult,
} from "@/request/api/allChildrenProject";
import { _pictureupload_save } from "@/request/api/public";
import { myRequest } from "@/request/index";
import {
  selectCheck,
  confirmCallBack,
  messageTip,
  createObjParams,
  formatDare,
} from "@/utils/util";

export default {
  mixins: [part],
  name: "techexam",
  components: { Export, Import },
  props: {
    importSaveUrl: {
      default: () => techexam_importsave,
    },
    techfudao_dialogresult: {
      default: () => techfudao_dialogresult,
    },
    importSaveUrl2: {
      default: () => techexamdetail_importsave,
    },
  },
  data() {
    return {
      importDialog: false, //导入名单
      importDialog2: false, //导入成绩
      itemId: null, //首表格项id
      searchForm: {},
      tableRes: {}, //列表接口
      pageinfo: {
        pageindex: 1,
        pagesize: 10,
      }, //页数查询
      showAddModal: false, // 添加
      showDetailModal: false, // 查看详情
      multipleSelection: [], //选中的表格项
      dynamicValidateForm: {}, //表单
      rules: {
        companyorgid: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        schoolorgid: [{ trigger: "blur", message: "必填字段", required: true }],
        studentname: [{ trigger: "blur", message: "必填字段", required: true }],
        examtype: [{ trigger: "blur", message: "必填字段", required: true }],
        totalscore: [{ trigger: "blur", message: "必填字段", required: true }],
      }, //表单规则
      dialogTitle: "", //对话框标题
      fds: new FormData(),

      showDeliModal: false, //德立学生

      isDisable: false,

      showModal: false,
      showTable: {},
      showDetailEditModal: false,
      selectPageInfo: {
        pageindex: 1,
        pagesize: 10,
      },
      status: {
        1: "是",
        0: "否",
      },
      selectTableUrl: null,
      selectTable: {},
      
      selectSchoolorgid: null,
      selectSearchForm: {},
      tech_projectTyles: [],
    };
  },
  created() {
    this.getDataList();
    this.org_combox();
    this.org_comboxchild(this.dynamicValidateForm.companyorgid);
    this.dic_combox({
      list: "tech_projectTyles",
      typecode: "skill",
      that: this,
    });
		window.addEventListener("keyup", this.enterSelect);
  },
  methods: {
    ...mapActions("selectData", ["dic_combox"]),
    ...mapActions("global", ["onExtendClick", "isExpand"]),
    ...mapActions("selectData", ["org_combox", "org_comboxchild"]),
    //改变分公司 change
    onChangeCompany(val, form) {
      this[form].schoolorgname = "";
      this[form].companyorgid = val;
      this.org_comboxchild(val);
    },
    onChangeSchool(val, form) {
      this[form].schoolorgid = val;
    },
    //关闭导入框
    onCloseImport(bool) {
      this.importDialog = bool;
    },
    //关闭导入框
    onCloseImport2(bool) {
      this.importDialog2 = bool;
    },
    //导入名单 click
    btnImport1() {
      this.importDialog = true;
    },
    //导入成绩 click
    btnImport2() {
      this.importDialog2 = true;
    },
		enterSelect(e) {
			if(e.keyCode == 13) {
				this.getDataList();
			}
		},
		visibleType(e) {
			if(!e) {
				this.$refs.projecttyperef.blur();
			}
		},
		reset() {
			this.searchForm = {
				studentname: null,
				projecttype: null,
				fudaoclasstypename: null,
				schoolorgname: null
			}
		},
		//重置
		resetQuery() {
			this.reset();
			this.getDataList();
		},
    //搜索 click
    seach() {
      this.pageinfo.pageindex = 1;
      this.getDataList();
    },
    //列表查询 api
    getDataList() {
      myRequest({
        url: techexam_list,
        data: Object.assign(this.searchForm, this.pageinfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.tableRes = res.data.data;
        }
      });
    },
    //切换当前页
    handleCurrentChange(val) {
      this.pageinfo.pageindex = val;
      this.getDataList();
    },
    //切换详情表格页
    handleShowChange(val) {
      this.pageinfo.pageindex = val;
      this.showList();
    },

    //触发所有btn方法
    onClickBtn(methodsName) {
      this.$options.methods[methodsName].call(this); //btnAdd ... （防止修改this指向）
    },

    // 查看详情路由页 api
    btnShowDetail(row) {
      myRequest({
        url: techexam_input,
        data: {
          id: row.id,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.showDetailModal = true;
          this.dialogTitle = "查看";
          this.dynamicValidateForm = {};
          this.dynamicValidateForm = res.data.data.vtechexam;
        }
      });
    },

    //添加click
    btnAdd() {
      this.dialogTitle = "添加";
      this.dynamicValidateForm = {
        schoolorgid: this.$store.state.login.userinfo.schoolorgid,
        companyorgid: this.$store.state.login.userinfo.companyorgid,
      };
      this.$set(this.dynamicValidateForm,'companyorgname',this.$store.state.login.userinfo.companyorgname)
      this.$set(this.dynamicValidateForm,'schoolorgname',this.$store.state.login.userinfo.schoolorgname)
      this.org_comboxchild(this.dynamicValidateForm.companyorgid);
      this.showAddModal = true;
    },

    //查看详情 click
    btnShow(row) {
      this.itemId = row.id;
      this.showList();
    },
    //删除click
    btnDel() {
      selectCheck(this.multipleSelection, "删除", true, () => {
        confirmCallBack({
          title: "提示",
          content: "此操作将永久删除选中的数据！",
          success: () => {
            this.delTableItem(this.multipleSelection.map((i) => i.id));
          },
          fail: () => {
            messageTip({
              message: "取消操作",
              type: "info",
            });
          },
        });
      });
    },
    //上传文件前 before
    beforeUpload(file) {
      this.fds.append("upfile", file); // 传文件
    },
    //上传文件 upload
    uploadFile() {
      myRequest({
        method: "post",
        url: _pictureupload_save,
        data: this.fds,
      }).then((res) => {
        if (res.data.code === "200") {
          this.dynamicValidateForm.fileurl = res.data.url;
        }
      });
    },
    //确认德立学生 click
    onConfirmDeli() {
      selectCheck(this.multipleSelection, "确认德立学生", false, () => {
        this.$set(this.dynamicValidateForm,'studentname',this.multipleSelection[0].studentname)
        this.dynamicValidateForm.techfudaoid = this.multipleSelection[0].id;
        this.showDeliModal = false;
      });
    },
    //导出成绩 click api
    exportAllTable() {
      confirmCallBack({
        title: "提示",
        content: "根据搜索条件进行导出。",
        success: () => {
          window.location.href =
            this.$store.state.global.baseUrl +
            techexamdetail_exportscore +
            `?${createObjParams(this.searchForm)}`;
        },
        fail: () => {
          messageTip({
            message: "取消操作",
            type: "info",
          });
        },
      });
    },
    //查看详情的修改 click
    btnDetailEdit() {
      this.dialogTitle = "修改";
      this.dynamicValidateForm = {};
      selectCheck(this.multipleSelection, "修改", false, () => {
        this.editDetailRoutePage(this.multipleSelection[0].id);
      });
    },
    //查看详情的删除 click
    btnDetailDel() {
      selectCheck(this.multipleSelection, "删除", true, () => {
        confirmCallBack({
          title: "提示",
          content: "此操作将永久删除选中的数据！",
          success: () => {
            this.delDetail(this.multipleSelection.map((i) => i.id));
          },
          fail: () => {
            messageTip({
              message: "取消操作",
              type: "info",
            });
          },
        });
      });
    },
    //刷新 click
    btnReload() {
      this.getDataList();
    },
    //详情的保存 api
    saveDetail() {
      this.dynamicValidateForm.status =
        this.dynamicValidateForm.status == "是" ? 1 : 0;
      myRequest(
        {
          url: techexamdetail_save,
          data: this.dynamicValidateForm,
        },
        {
          that: this,
          isRefTableList: true,
          modal: "showDetailEditModal",
          methodName: "showList",
        }
      );
    },
    //详情的修改路由页 api
    editDetailRoutePage(id) {
      myRequest({
        url: techexamdetail_input,
        data: {
          id: id,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.showDetailEditModal = true;
          this.dynamicValidateForm = res.data.data.vtechexamdetail;
          this.dynamicValidateForm.status = this.status[
            this.dynamicValidateForm.status
          ];
          delete this.dynamicValidateForm.inserttime; //inserttime 该字段不用传
          delete this.dynamicValidateForm.isoktime; //isoktime 该字段不用传
        }
      });
    },
    //查看详情的删除 api
    delDetail(idArr) {
      myRequest(
        {
          method: "post",
          url: techexamdetail_delete,
          data: this.$qs.stringify(
            {
              ids: idArr,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          methodName: "showList",
          modal: "showDetailEditModal",
          that: this,
        }
      );
    },
    //查看 api
    showList() {
      myRequest({
        url: techexamdetail_list,
        data: {
          pagesize: this.pageinfo.pagesize,
          pageindex: this.pageinfo.pageindex,
          techexamid: this.itemId,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.showTable = res.data.data;
          this.showModal = true;
        }
      });
    },

    //删除 api
    delTableItem(idArr) {
      myRequest(
        {
          method: "post",
          url: techexam_delete,
          data: this.$qs.stringify(
            {
              ids: idArr,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          isRefTableList: true,
          that: this,
        }
      );
    },
   


    //选中表格数据改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>

<style  lang="scss">
</style>